import { z } from "zod";
import { createEndpoint, createEndpointWithPagination, StandardSuccessResponseSchema } from "../createEndpoint";
import type { HttpClient } from "../httpClient";
import { MediaSchema, MediaStatsSchema, type MediaListQueryParams } from "../schemas/media";

export function createAdminMediaApi(http: HttpClient, baseUrl: string) {
    const adminMediaBaseUrl = `${baseUrl}/admin/media`;
    
    return {
        list: createEndpointWithPagination<z.infer<typeof MediaSchema>, undefined, MediaListQueryParams>(
            http,
            'GET',
            '',
            {
                base: adminMediaBaseUrl,
                itemSchema: MediaSchema,
            }
        ),

        delete: createEndpoint<
            z.infer<typeof StandardSuccessResponseSchema>,
            undefined,
            { force?: boolean },
            { media: string }
        >(
            http,
            'DELETE',
            '/:media',
            {
                base: adminMediaBaseUrl,
                responseSchema: StandardSuccessResponseSchema,
                params: ['media'],
            }
        ),

        restore: createEndpoint<
            z.infer<typeof MediaSchema>,
            undefined,
            Record<string, never>,
            { media: string }
        >(
            http,
            'POST',
            '/:media/restore',
            {
                base: adminMediaBaseUrl,
                responseSchema: MediaSchema,
                params: ['media'],
            }
        ),

        stats: createEndpoint<z.infer<typeof MediaStatsSchema>>(
            http,
            'GET',
            '/stats',
            {
                base: adminMediaBaseUrl,
                responseSchema: MediaStatsSchema,
            }
        ),

        cleanupTemporary: createEndpoint<{ deleted_count: number }>(
            http,
            'POST',
            '/cleanup-temporary',
            {
                base: adminMediaBaseUrl,
                responseSchema: z.object({
                    deleted_count: z.number(),
                }),
            }
        ),
    }
}

export type AdminMediaApi = ReturnType<typeof createAdminMediaApi>;

